var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockSmartRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 9.79086 3.79086 8 6 8H30C32.2091 8 34 9.79086 34 12V36C34 38.2091 32.2091 40 30 40H6C3.79086 40 2 38.2091 2 36V12ZM43 9.5C43 8.67157 43.6716 8 44.5 8C45.3284 8 46 8.67157 46 9.5V38.5C46 39.3284 45.3284 40 44.5 40C43.6716 40 43 39.3284 43 38.5V9.5ZM38.5 8C37.6716 8 37 8.67157 37 9.5V38.5C37 39.3284 37.6716 40 38.5 40C39.3284 40 40 39.3284 40 38.5V9.5C40 8.67157 39.3284 8 38.5 8Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockSmartRecord);
export default __webpack_public_path__ + "static/media/block-smart-record.e8490a2f224bbc6e73e6bf09d0665e4f.svg";
export { ForwardRef as ReactComponent };